<template>
  <div>
    <!-- loader -->
    <!-- <div class="loader-wrapper">
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div> -->
    <!-- loader end -->

   
    <!-- home section -->
    <section class="menu-bg home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="menu">
          <router-link to="/menu1">    <img 
                  src="../assets/images/menu.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 100px;"
                /></router-link>
              </div>
              <div class="menu-back">
                <a @click="playsound();$router.go(-1);">
<img
                  src="../assets/images/menu-back.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
</a>
              </div>
              <div class="menu-next">
                <img
                  src="../assets/images/menu-next.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
              </div>
        <div class="row justify-content-center">
          <!-- <div class="col-md-6">
            <div class="home-contain">
              <div class="fadeInLeft-land-caption">
                <h2 class="landing-caption text-white">
                  Best App Landing for all your needs.. !
                </h2>
                <p class="text-white">
                  Chatloop is perfect landing page for game , photoediting ,
                  browser or any mobile application landing page
                </p>
                <div>
                  <router-link
                    to="/chatloop/index"
                    class="btn btn-inverse mt-2 mr-3"
                    >Ltr Demo</router-link
                  >
                  <router-link to="/chatloop/rtl" class="btn btn-inverse mt-2"
                    >Rtl Demo</router-link
                  >
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-md-3">
           
          </div> -->
        
            
          <div class="col-md-6">
            <div class="home-right">
              <div class="mobile-slid">
                <img
                  src="../assets/images/bg-popup-menu.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="menu_head">
                <img
                  src="../assets/images/menu-head.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
             
              <div class="menu1">
                <img
                  src="../assets/images/menu-menu1.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="menu2">
                <img
                  src="../assets/images/menu-menu2.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="menu3">
                <img
                  src="../assets/images/menu-menu3.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="menu4">
                <img
                  src="../assets/images/menu-menu4.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="menu5">
                <img
                  src="../assets/images/menu-menu5.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              
            
            
            </div>
          </div>
         
          <!-- <div class="col-md-3">
            <div class="photo">
                <img
                  src="../assets/images/demo/home/photo-Editing-app.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
          </div> -->
        </div>
      </div>
      <div class="love-emoji">
                <img
                  src="../assets/images/chid1.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 350px;"
                />
              </div>
              <div class="love-emoji2">
                <img
                  src="../assets/images/child2.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 350px;"
                />
              </div>
              <div class="row" >

              </div>
    </section>
    <!-- home section end -->

  
    <!--Footer Section End-->
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
    };
  },
  mounted() {
   // this.loader();
  },
  methods: {
    loader() {
      $(document).ready(function () {
        $(window).on("load", function () {
          $(".loader-wrapper").fadeOut("slow");
          $(".loader-wrapper").remove("slow");
        });
      });
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
